// bingo-fallback.js — the original local autoplay loop, now used ONLY when the
// real demo engine is unavailable (offline / blocked script / endpoint down).
// Exposes start()/stop(); demo-source.js owns when it runs.

import { FALLBACK_SEQUENCE, buildFallbackState } from './demo-state.js';

var INTERVAL = 2400;
var INITIAL_INDEX = 10;

var idx = INITIAL_INDEX;
var timer = null;
var running = false;

function publish() {
  document.dispatchEvent(new CustomEvent('bingocall', { detail: buildFallbackState(idx) }));
}

function tick() {
  if (document.hidden) return; // pause while tab is hidden
  idx = (idx + 1) % FALLBACK_SEQUENCE.length;
  publish();
}

export function start() {
  if (running) return;
  running = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  publish(); // render one frame immediately
  if (!reduced) timer = setInterval(tick, INTERVAL);
}

export function stop() {
  running = false;
  if (timer) { clearInterval(timer); timer = null; }
}

export function isRunning() { return running; }
